import { FlexBox, ListPrice, Pricing, Typography } from '@vp/swan';
import { PriceFromFloat } from '@99designs/design-services-common';
import type { Price } from '../pageData/priceConfig';
import type { Tier } from '../pageData/tierConfig';

interface ProductTierSectionProps {
    tier: Tier;
    price: Price;
}

export const ProductTierSection = ({ tier, price }: ProductTierSectionProps) => {
    const { icon, title, mobileDescription } = tier;

    return (
        <FlexBox
            flexDirection="column"
            justifyContent="space-between"
            style={{ height: '100%' }}
            mb={4}
        >
            <FlexBox justifyContent="space-between">
                <FlexBox flexDirection="row">
                    {icon}
                    <FlexBox flexDirection="column" ml={2} justifyContent="space-between">
                        <Typography fontSkin="title-subsection">{title}</Typography>
                        <Pricing>
                            <ListPrice fontSkin="title-subsection">
                                <PriceFromFloat amount={price.amount} currency={price.currency} />
                            </ListPrice>
                        </Pricing>
                    </FlexBox>
                </FlexBox>
            </FlexBox>
            <Typography fontWeight="normal" my={3}>
                {mobileDescription}
            </Typography>
        </FlexBox>
    );
};
